/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Pricing_SummaryInputs */

const en_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing Summary`)
};

const fr_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume des tarifs`)
};

const de_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisübersicht`)
};

const it_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo dei prezzi`)
};

const ru_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сводка цен`)
};

const es_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de precios`)
};

const zh_cn2_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价概要`)
};

const ja_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格概要`)
};

const hi_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य निर्धारण सारांश`)
};

const pt_pt2_embed_captions_pricing_summary = /** @type {(inputs: Embed_Captions_Pricing_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo de preços`)
};

/**
* | output |
* | --- |
* | "Pricing Summary" |
*
* @param {Embed_Captions_Pricing_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_summary = /** @type {((inputs?: Embed_Captions_Pricing_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_pricing_summary(inputs)
	if (locale === "de") return de_embed_captions_pricing_summary(inputs)
	if (locale === "it") return it_embed_captions_pricing_summary(inputs)
	if (locale === "ru") return ru_embed_captions_pricing_summary(inputs)
	if (locale === "es") return es_embed_captions_pricing_summary(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_pricing_summary(inputs)
	if (locale === "ja") return ja_embed_captions_pricing_summary(inputs)
	if (locale === "hi") return hi_embed_captions_pricing_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_pricing_summary(inputs)
	return en_embed_captions_pricing_summary(inputs)
});